import { createSelector } from '@reduxjs/toolkit'

import { getAttentionStatusCatalog } from 'partner360/entities/attentionStatuses'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** Shared status definitions; partner-specific masks remain in `CockpitAttentionStatus`. */
export const selectCockpitAttentionStatusCatalog = createSelector(
  selectFinancialCockpitState,
  ({ attentionDict }) => getAttentionStatusCatalog(attentionDict)
)
